import { Grid } from '@material-ui/core';
import { FC } from 'react';
import SelectedTag from '../../../../../types/SelectedTag';
import StyledChip from '../StyledChip';

type Props = {
  selectedTags: SelectedTag[];
  setSelectedTags: (value: React.SetStateAction<SelectedTag[]>) => void;
};

const TagContent: FC<Props> = ({ selectedTags, setSelectedTags }) => {
  return (
    <Grid item xs={12}>
      {selectedTags.map((tag, index) => {
        return (
          <StyledChip
            key={tag.tag.id}
            label={tag.tag.name}
            clickable
            variant="outlined"
            selected={tag.selected}
            onClick={() => {
              selectedTags[index].selected = !selectedTags[index].selected;
              setSelectedTags(selectedTags.slice());
            }}
          />
        );
      })}
    </Grid>
  );
};

export default TagContent;
